import React from 'react'
import { Collection, ExecuteOperationOnPipe, useValue } from '@morningtrain/react-resources'
import AdjustScheduleButton from 'widgets/smartviews/partials/AdjustScheduleButton'
import * as UI from 'ui'
import PropTypes from "prop-types";

export default function ForecastAdjuster (props) {
  const { weekDay } = props
  const scheduleId = useValue('schedule_id')

  const refreshPipes = (
    <>
      <ExecuteOperationOnPipe resourceName='dashboard' operationName='forecast_summary' />
      <ExecuteOperationOnPipe resourceName='shifts.schedule' operationName='day_summary' operationContext={{ scheduleId: scheduleId }} />
    </>
  )

  return (
    <div className='group space-x-1'>
      <AdjustScheduleButton scheduleId={scheduleId} step={-500} weekDay={weekDay} pipes={refreshPipes}>
        <UI.SquareButton color='btn-lightgray'>
          <svg className='w-3' width='12' height='1.091' viewBox='0 0 12 1.091'>
            <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-96 -202.668)' />
          </svg>
        </UI.SquareButton>
      </AdjustScheduleButton>
      <AdjustScheduleButton scheduleId={scheduleId} step={500} weekDay={weekDay} pipes={refreshPipes}>
        <UI.SquareButton color='btn-lightgray'>
          <svg className='w-3' width='12' height='12' viewBox='0 0 12 12'>
            <g transform='translate(-3.6 -3.6)'>
              <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-92.4 -193.613)' />
              <path d='M202.668,96h1.091v12h-1.091Zm0,0' transform='translate(-193.613 -92.4)' />
            </g>
          </svg>
        </UI.SquareButton>
      </AdjustScheduleButton>
    </div>
  )
}

ForecastAdjuster.propTypes = {
  weekDay: PropTypes.number
}
